var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { convertToCSSValue, getGeometryStyle, getMaximumWidth, getMinimumWidth, } from '../../helpers/styles';
import ChildItemWidget from '../ChildItemWidget';
var getPaddingStyle = function (padding) {
    if (!padding)
        return '';
    return "\n  " + (padding.paddingLeft
        ? "padding-left: " + convertToCSSValue(padding.paddingLeft) + ";"
        : '') + ";\n  " + (padding.paddingRight
        ? "padding-right: " + convertToCSSValue(padding.paddingRight) + ";"
        : '') + ";\n  " + (padding.paddingTop
        ? "padding-top: " + convertToCSSValue(padding.paddingTop) + ";"
        : '') + ";\n  " + (padding.paddingBottom
        ? "padding-bottom: " + convertToCSSValue(padding.paddingBottom) + ";"
        : '') + ";\n  ";
};
var StyledHBoxLayout = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  min-width: ", ";\n  max-width: ", ";\n  display: ", ";\n  flex-direction: ", ";\n  justify-content: ", ";\n  margin-top: ", ";\n  height: ", ";\n  width: ", ";\n  align-items: ", ";\n  text-align: ", ";\n  div[data-widget-type='item'] {\n    height: ", ";\n    width: ", ";\n    margin: ", ";\n  }\n"], ["\n  ", "\n  ", "\n  min-width: ", ";\n  max-width: ", ";\n  display: ", ";\n  flex-direction: ", ";\n  justify-content: ",
    ";\n  margin-top: ", ";\n  height: ", ";\n  width: ", ";\n  align-items: ",
    ";\n  text-align: ", ";\n  div[data-widget-type='item'] {\n    height: ", ";\n    width: ",
    ";\n    margin: ", ";\n  }\n"])), function (_a) {
    var geometry = _a.attributes.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var padding = _a.attributes.padding;
    return getPaddingStyle(padding);
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return getMinimumWidth(minimumSize);
}, function (_a) {
    var maximumSize = _a.maximumSize;
    return getMaximumWidth(maximumSize);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.hBoxLayout.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.hBoxLayout.flexDirection;
}, function (_a) {
    var windowTheme = _a.windowTheme, attributes = _a.attributes;
    var _b;
    return (_b = attributes === null || attributes === void 0 ? void 0 : attributes.justifyContent) !== null && _b !== void 0 ? _b : windowTheme.hBoxLayout.justifyContent;
}, function (_a) {
    var topMargin = _a.attributes.topMargin;
    return topMargin + "px";
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.hBoxLayout.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.hBoxLayout.width;
}, function (_a) {
    var windowTheme = _a.windowTheme, attributes = _a.attributes;
    var _b;
    return (_b = attributes === null || attributes === void 0 ? void 0 : attributes.alignItems) !== null && _b !== void 0 ? _b : windowTheme.hBoxLayout.alignItems;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.hBoxLayout.textAlign;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.hBoxLayout.item.height;
}, function (_a) {
    var windowTheme = _a.windowTheme, attributes = _a.attributes;
    var _b;
    return (_b = attributes === null || attributes === void 0 ? void 0 : attributes.itemWidth) !== null && _b !== void 0 ? _b : windowTheme.hBoxLayout.item.width;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.hBoxLayout.item.margin;
});
var HBoxLayout = function (props) {
    return (React.createElement(StyledHBoxLayout, __assign({}, props),
        React.createElement(ChildItemWidget, __assign({}, props))));
};
export default HBoxLayout;
var templateObject_1;
//# sourceMappingURL=index.js.map